import { createContext, useContext } from "react";
import { SingleLineConfig } from "./types";

type SingleLineContextType = {
  singleLineConfig?: SingleLineConfig;
  toggleTurbineStatus: (id: string) => void;
  toggleTurbineInterlock: (id: string) => void;
  toggleTurbinePersonnel: (id: string) => void;
  getNode: (id: string) => any;
};

export const SingleLineContext = createContext<
  SingleLineContextType | undefined
>(undefined);

export const useSingleLine = (): SingleLineContextType => {
  const context = useContext(SingleLineContext);
  if (context === undefined) {
    throw new Error("useSingleLine must be used within a SingleLineProvider");
  }
  return context;
};
